
import axios, { AxiosResponse } from 'axios'
import { FC, createContext, useEffect, useState } from 'react'

const MOBILE_CATEGORY_ID = '206'
const WEB_CATEGORY_ID = '205'
const WEB_AND_MOBILE_CATEGORY_ID = '209'
const BACKEND_PRODUCTS_UNIT = 'Vraag 5'
const PAGE_PRICE_PRODUCT_ID = 31
const MOBILE_APP_BASE_PRICE = 4
const WEB_APP_BASE_PRICE = 5
const MOBILE_AND_WEB_APP_BASE_PRICE = 7

const BASE_URL = 'https://api.pipedrive.com/v1'

interface ProductContextType {
  allProducts: IProduct[]
  mobileProducts: IProduct[]
  backendProducts: IProduct[]
  webProducts: IProduct[]
  mobileBaseProduct: IProduct | null
  webBaseProduct: IProduct | null
  mobileAndWebBaseProduct: IProduct | null
  pagePriceProduct: IProduct | null
}

export interface IProduct {
  active_flag: boolean
  category: string
  id: number
  name: string
  prices: Array<{ price: number }>
  unit: string
}

export const ProductContext = createContext<ProductContextType>({
  allProducts: [],
  mobileProducts: [],
  webProducts: [],
  backendProducts: [],
  mobileBaseProduct: null,
  webBaseProduct: null,
  mobileAndWebBaseProduct: null,
  pagePriceProduct: null
})

interface IProps {
  children: React.ReactNode
}

interface IResponse {
  data: IProduct[]
}

const ProductsProvider: FC<IProps> = ({ children }) => {
  const [mobileProducts, setMobileProducts] = useState<IProduct[]>([])
  const [webProducts, setWebProducts] = useState<IProduct[]>([])
  const [mobileBaseProduct, setMobileBaseProduct] = useState<IProduct | null>(null)
  const [backendProducts, setBackendProducts] = useState<IProduct[]>([])
  const [webBaseProduct, setWebBaseProduct] = useState<IProduct | null>(null)
  const [mobileAndWebBaseProduct, setMobileAndWebBaseProduct] = useState<IProduct | null>(null)
  const [pagePriceProduct, setPagePriceProduct] = useState<IProduct | null>(null)
  const [allProducts, setAllProducts] = useState<IProduct[]>([])

  const fetchProducts = async (): Promise<AxiosResponse<IResponse, any>> => {
    return await axios.get(`${BASE_URL}/products?api_token=${String(process.env.REACT_APP_API_TOKEN)}`)
  }

  useEffect(() => {
    fetchProducts().then(({ data }) => {
      data.data.forEach(product => {
        if (product.id === PAGE_PRICE_PRODUCT_ID) {
          setPagePriceProduct(product)
        } else if (product.id === MOBILE_APP_BASE_PRICE) {
          setMobileBaseProduct(product)
        } else if (product.id === WEB_APP_BASE_PRICE) {
          setWebBaseProduct(product)
        } else if (product.id === MOBILE_AND_WEB_APP_BASE_PRICE) {
          setMobileAndWebBaseProduct(product)
        }
      })

      // All products
      setAllProducts(data.data)

      // Mobile products
      const mobileProducts = data.data.filter(product => (product.category === MOBILE_CATEGORY_ID || product.category === WEB_AND_MOBILE_CATEGORY_ID) && product.id !== MOBILE_APP_BASE_PRICE && product.id !== MOBILE_AND_WEB_APP_BASE_PRICE && product.id !== PAGE_PRICE_PRODUCT_ID && product.unit !== BACKEND_PRODUCTS_UNIT)
      setMobileProducts(mobileProducts)

      // Web products
      const webProducts = data.data.filter(product => (product.category === WEB_CATEGORY_ID || product.category === WEB_AND_MOBILE_CATEGORY_ID) && product.id !== WEB_APP_BASE_PRICE && product.id !== MOBILE_AND_WEB_APP_BASE_PRICE && product.id !== PAGE_PRICE_PRODUCT_ID && product.unit !== BACKEND_PRODUCTS_UNIT)
      setWebProducts(webProducts)

      // Backend products
      const backendProducts = data.data.filter(product => product.unit === BACKEND_PRODUCTS_UNIT)
      setBackendProducts(backendProducts)
    }).catch(err => console.log(err))
  }, [])

  return <ProductContext.Provider value={{ allProducts, mobileProducts, webProducts, backendProducts, mobileBaseProduct, webBaseProduct, mobileAndWebBaseProduct, pagePriceProduct }}>{children}</ProductContext.Provider>
}

export default ProductsProvider
